import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IAlertMessage } from 'src/app/core/models/models';

@Component({
  selector: 'app-alert-messages-modal',
  templateUrl: './alert-messages-modal.component.html',
  styleUrls: ['./alert-messages-modal.component.css']
})
export class AlertMessagesModalComponent implements OnChanges {
  @Input() isActive: boolean;
  @Input() alertMessages: IAlertMessage[];
  @Input() totalAlerts: number;

  @Output() closeModal = new EventEmitter<boolean>();
  @Output() allMessagesAcepted = new EventEmitter<boolean>();

  currentMessage = '';
  currentTranslate = false;
  currentMessageIndex = 0;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isActive?.currentValue) {
      this.currentMessage = this.alertMessages[0]?.message;
      this.currentTranslate = this.alertMessages[0]?.translate;
      this.currentMessageIndex = 1;
    }
  }

  aceeptAndNext() {
    if (this.currentMessageIndex === this.totalAlerts) {
      this.acceptedAll();
    } else {
      this.currentMessage = this.alertMessages[this.currentMessageIndex]?.message
      this.currentTranslate = this.alertMessages[this.currentMessageIndex]?.translate
    }
    this.currentMessageIndex++;
  }

  acceptedAll() {
    this.allMessagesAcepted.emit(true);
  }

  exit() {
    this.closeModal.emit(true);
  }
}
